module.exports = __webpack_public_path__ + "static/media/img127.c5bc4bee.jpg";